import React, { Component } from 'react'
import classes from './Destination.module.css'
import { Spinner } from '../../Component/Spinner/Spinner'
import { Tabs } from '../../Component/UI/Tabs/Tabs'

export default class Destination extends Component {

    state = {
        items: 0,
        data: []
    }

    componentDidMount() {
        
        fetch('data.json')
        .then(res => res.json())
        .then(data => {
            console.log(data.destinations)
            this.setState({data: data.destinations[this.state.items]})
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.items !== prevState.items) {
            fetch('data.json')
            .then(res => res.json())
            .then(data => {
                this.setState({data: data.destinations[this.state.items]})
            }) 
        }
    }


    changeTabHandler = index => {
        console.log(index)
        console.log(this.state.items)
        this.setState({items: index})
    }

    activeTabs = index => {
        if (this.state.items === index) {
            return "border-b-2"
        }
    }

    render() {
        
        let destinationData = <Spinner />
        

        if (this.state.data.length !== 0) {
    
           destinationData = (
            
            <div className=" sm:py-32 md:py-32 lg:py-0 px-9 lg:grid grid-cols-2 lg:pt-36 lg:pb-14" >
                <section className="text-center pt-14 row-start-1 row-end-1">
                    <h4 className="text-white text-xl tracking-widest lg:pb-12 lg:text-4xl"><span className=" text-blue-700 font-bold mr-4">01</span>PICK YOUR DESTINATION</h4>
                    <img src={this.state.data.images.png} alt="planet" className="mt-12 lg:m-auto"/>
                </section>
               
                <section className="row-start-1 row-end-1">
                    <section className="lg:pr-64 xl:pr-80">
                        <Tabs>
                            <button className={this.activeTabs(0)} onClick={() => this.changeTabHandler(0)}>MOON</button>
                            <button className={this.activeTabs(1)} onClick={() => this.changeTabHandler(1)}>MARS</button>
                            <button className={this.activeTabs(2)} onClick={() => this.changeTabHandler(2)}>EUROPA</button>
                            <button className={this.activeTabs(3)} onClick={() => this.changeTabHandler(3)}>TITAN</button>
                        </Tabs>
                        
                    </section>

                    <div className="mt-10">
                        <h1 className="font-Bellefair text-white text-6xl lg:text-left lg:text-8xl">{this.state.data.name.toUpperCase()}</h1>
                        <p className="text-softGray mt-10 lg:text-left lg:text-3xl lg:leading-relaxed">{this.state.data.description}</p>

                        <div className="mt-14 border-t-2 border-softGray pt-7 lg:mr-40 lg:flex flex-row justify-between">
                            <section className="mb-14">
                                <h5 className="text-softGray text-xl">AVG DISTANCE</h5>
                                <h1 className="text-white text-4xl font-Bellefair mt-3">{this.state.data.distance.toUpperCase()}</h1>
                            </section>

                            <section>
                                <h5 className="text-softGray text-xl">EST. TRAVEL TIME</h5>
                                <h1 className="text-white text-4xl font-Bellefair mt-3">{this.state.data.travel.toUpperCase()}</h1>
                            </section>
                        </div>
                    </div>
                </section>
                
                
            </div>
           )
        }
        return (
            
            <div className={classes.container}>
                {destinationData}
            </div>
           
        )
    }
}
